import React, { useState } from 'react';
import MonitorWeightOutlined from '@mui/icons-material/MonitorWeightOutlined';
import HeightOutlined from '@mui/icons-material/HeightOutlined';
import FavoriteBorderOutlined from '@mui/icons-material/FavoriteBorderOutlined';
import { useToast } from '../../context/ToastContext';
import {
    WarningAmber,
    MonitorHeart,
    Edit as EditIcon
} from '@mui/icons-material';
import ModalEditarAntecedentes from './ModalEditarAntecedentes';

const PanelBiometria = ({ paciente, onActualizar }) => {
    const { showToast } = useToast();
    const [openEditModal, setOpenEditModal] = useState(false);

    if (!paciente) return null;

    const limpiarTextoClinico = (texto) => {
        if (!texto) return '';
        let str = String(texto).trim();
        if (str.startsWith('[') && str.endsWith(']')) {
            try {
                const parsed = JSON.parse(str);
                if (Array.isArray(parsed)) return parsed.join(', ');
            } catch (e) {
                // No es un JSON válido, ignoramos y seguimos con el texto plano
                console.warn('Error al parsear JSON en antecedentes clínicos:', e.message);
            }
        }
        return str.replace(/^"+|"+$/g, '').trim();
    };

    const alergiasLimpias = limpiarTextoClinico(paciente.alergias);
    const antecedentesLimpios = limpiarTextoClinico(paciente.antecedentes);

    return (
        <div className="bg-white border border-slate-200 rounded-3xl shadow-sm p-8">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4 mb-8 border-b border-slate-100 pb-6">
                <div>
                    <h3 className="text-2xl font-black text-slate-900 tracking-tight">Dashboard Clínico</h3>
                    <p className="text-sm font-semibold text-slate-500 mt-1">
                        Resumen de antecedentes, alergias y constantes vitales fijas.
                    </p>
                </div>
                <button
                    onClick={() => setOpenEditModal(true)}
                    className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-bold rounded-xl transition-all shadow-sm shrink-0"
                >
                    <EditIcon fontSize="small" />
                    Editar Perfil Médico
                </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Alergias */}
                <div className="p-6 bg-red-50/80 border border-red-100 rounded-2xl lg:col-span-2 shadow-sm">
                    <div className="flex items-center gap-2 text-red-600 mb-3">
                        <WarningAmber fontSize="small" />
                        <span className="text-xs font-black uppercase tracking-widest">Reacciones Adversas y Alergias (RAM)</span>
                    </div>
                    <p className="text-base font-bold text-red-900 leading-relaxed">
                        {alergiasLimpias || 'Sin alergias médicas conocidas notificadas en el triaje.'}
                    </p>
                </div>

                {/* Antecedentes (incluye patologías crónicas y medicación) */}
                <div className="p-6 bg-amber-50/80 border border-amber-100 rounded-2xl lg:col-span-2 shadow-sm">
                    <div className="flex items-center gap-2 text-amber-600 mb-3">
                        <MonitorHeart fontSize="small" />
                        <span className="text-xs font-black uppercase tracking-widest">Antecedentes y Medicación Habitual</span>
                    </div>
                    <p className="text-sm font-bold text-amber-900 leading-relaxed">
                        {antecedentesLimpios || 'No constan antecedentes ni medicación habitual.'}
                    </p>
                </div>
            </div>

            <div className="mt-8 pt-8 border-t border-slate-100">
                <h4 className="text-xs font-black text-slate-400 uppercase tracking-widest mb-6">
                    Constantes y Biometría Base
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div className="flex flex-col items-center justify-center p-5 bg-slate-50 border border-slate-100 rounded-2xl opacity-60 border-dashed">
                        <MonitorWeightOutlined className="text-slate-400 mb-2" aria-hidden="true" />
                        <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Peso Base</span>
                        <span className="text-xs font-bold text-slate-400">Próximamente</span>
                    </div>
                    <div className="flex flex-col items-center justify-center p-5 bg-slate-50 border border-slate-100 rounded-2xl opacity-60 border-dashed">
                        <HeightOutlined className="text-slate-400 mb-2" aria-hidden="true" />
                        <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Altura</span>
                        <span className="text-xs font-bold text-slate-400">Próximamente</span>
                    </div>
                    <div className="flex flex-col items-center justify-center p-5 bg-slate-50 border border-slate-100 rounded-2xl opacity-60 border-dashed">
                        <FavoriteBorderOutlined className="text-slate-400 mb-2" aria-hidden="true" />
                        <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Tensión</span>
                        <span className="text-xs font-bold text-slate-400">Próximamente</span>
                    </div>
                </div>
            </div>

            <ModalEditarAntecedentes
                open={openEditModal}
                onClose={() => setOpenEditModal(false)}
                paciente={paciente}
                onSuccess={onActualizar}
                mostrarToast={showToast}
            />
        </div>
    );
};

export default PanelBiometria;